import { createRouter, useRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { ErrorState } from "@/components/site/ErrorState";
import { NotFoundPage } from "@/components/site/NotFoundPage";

function DefaultErrorComponent({ error, reset }: { error: unknown; reset: () => void }) {
  const router = useRouter();
  console.error(error);
  return (
    <ErrorState
      detail={error instanceof Error ? error.message : String(error)}
      onRetry={() => {
        router.invalidate();
        reset();
      }}
    />
  );
}

export const getRouter = () => {
  const router = createRouter({
    routeTree,
    context: {},
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
    defaultErrorComponent: DefaultErrorComponent,
    defaultNotFoundComponent: NotFoundPage,
    notFoundMode: "root",
    trailingSlash: "never",
  });

  return router;
};
